import React from "react";
import { Sun, Moon, CloudSun } from "lucide-react";
import { colones } from "@/lib/api";

const ICONS = { Diurna: Sun, Mixta: CloudSun, Nocturna: Moon };
const COLORS = { Diurna: "#D69E36", Mixta: "#4A788C", Nocturna: "#5D5673" };
const LETRA = { Diurna: "D", Mixta: "M", Nocturna: "N" };

// byJornada: { Diurna: {hrs, monto}, Mixta: {hrs, monto}, Nocturna: {hrs, monto} }
// Muestra cada jornada con sus horas; opcionalmente el monto total y el monto por jornada.
export default function HorasJornadaCell({ byJornada, showMonto = false, montoColor = "text-success" }) {
  if (!byJornada) return <span className="text-secondary-c">—</span>;
  const rows = Object.entries(byJornada)
    .map(([k, v]) => ({ jornada: k, hrs: v.hrs || 0, monto: v.monto || 0 }))
    .filter(r => r.hrs > 0);
  if (rows.length === 0) return <span className="text-secondary-c">—</span>;
  const totalHrs = rows.reduce((s, r) => s + r.hrs, 0);
  const totalMonto = rows.reduce((s, r) => s + r.monto, 0);

  return (
    <div>
      <div className="font-medium text-xs">{totalHrs.toFixed(2)}h</div>
      <div className="flex flex-wrap gap-1 mt-1">
        {rows.map(r => {
          const Ic = ICONS[r.jornada];
          return (
            <span
              key={r.jornada}
              title={`${r.jornada}: ${r.hrs.toFixed(2)}h · ${colones(r.monto)}`}
              className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-[#FAFAF7] border border-c text-[10px] font-medium"
              style={{ color: COLORS[r.jornada] }}
            >
              <Ic size={10} /> {r.hrs.toFixed(1)}h {LETRA[r.jornada]}
            </span>
          );
        })}
      </div>
      {showMonto && totalMonto > 0 && (
        <div className={`text-[11px] font-medium mt-0.5 ${montoColor}`}>{colones(totalMonto)}</div>
      )}
    </div>
  );
}
